import React from 'react';
import { Input, Form, TextArea } from 'semantic-ui-react';
import { Autocomplete, TextField } from "@mui/material";
import { withNamespaces } from 'react-i18next';

import CreateContext from '../../store/CreateContext';
import './styles.scss';


function ReportConfig(props) {
  const context = React.useContext(CreateContext);
  const { classes } = props;
  const onSave = (type, value, valid) => {
    if (type === 'report_name') {
      value = value.substring(0, 100);
      context.set_report_name({ value, valid });
    } else if (type === 'report_descr') {
      context.set_report_description({ value, valid });
    }
  };

  const handleReportInfo = (event) => {
    const id = event.target.id;
    const value = event.target.value;
    if (value) {
      onSave(id, value, true);
    } else {
      onSave(id, value, true);
    }
  };

  return <div className='col-md-12'>
    <Form size='tiny'>
      <Form.Group>
        <Form.Field required width={6}>
          <span className='label-euro' >{props.t("name_report")}</span><span style={{ color: '#db2828' }}>*</span>
          <TextField
            style={{ border: "0" }}
            // label={e.placeHolder} 
            id='report_name'
            variant="standard"
            type={"text"}
            name={"report_name"}
            value={context.report_name.value}
            InputProps={{
              classes: {
                input: 'input-euro',
              },
              border: "0"
            }}
            placeholder={props.t("name")}
            // onChange={this.handleChange(e.id, isEdit ? true : false, e.validation)}
            onChange={handleReportInfo}
          />
          {/* <Input fluid placeholder='Nombre del reporte' 
             id='report_name'
             name='report_name' onChange={handleReportInfo} /> */}
        </Form.Field>
        <Form.Field required width={6} >
          <span className="label-euro">{props.t("description")}</span><span style={{ color: '#db2828' }}>*</span>
          <TextField
            style={{ border: "0" }}
            // label={e.placeHolder} 
            placeholder={props.t("description")}
            variant="standard"
            type={"text"}
            id='report_descr'
            name='report_descr'
            value={context.report_description.value}
            InputProps={{
              classes: {
                input: 'input-euro',
              },
              border: "0"
            }}
            // onChange={this.handleChange(e.id, isEdit ? true : false, e.validation)}
            onChange={handleReportInfo}
          />

        </Form.Field>
      </Form.Group>
    </Form>
  </div>
    ;
}

export default withNamespaces()(ReportConfig);